import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Box, Icon, Stack, Tooltip } from '@emburse/embark-core';
import { useContext } from 'react';
import { HelpIcon } from '@emburse/embark-icons';
import { CreateExpenseReportContext } from '../../utils/CreateExpenseReportContext';
import { $t } from '../../../../hooks/useTranslation';
import { ALERT_TYPE } from '../../utils/constants';
import { INFO_ALERT_STYLES } from './style';
import { TOOLTIP_MESSAGES } from './config';
function AlertMessage() {
    const { alertType, expenseReportPreview: { ExpectedExpenseCount, ExpectedReceiptCount } } = useContext(CreateExpenseReportContext);
    const getAlertConfig = () => {
        switch (alertType) {
            case ALERT_TYPE.EMPTY_OPTION_WARNING:
                return {
                    severity: 'warning',
                    message: 'Please select which items to include by selecting an option below.'
                };
            case ALERT_TYPE.DATE_RANGE_OPTION_ERROR:
                return {
                    severity: 'error',
                    message: 'Please correct the errors listed below before going to the next page.'
                };
            case ALERT_TYPE.DATE_RANGE_EXPENSE_NUMBERS_INFO:
                return {
                    severity: 'info',
                    message: `${ExpectedExpenseCount} credit card transactions will be added to the expense report`,
                    hasTooltip: true,
                    tooltipMessage: TOOLTIP_MESSAGES.EXPENSES
                };
            case ALERT_TYPE.DATE_RANGE_EXPENSE_AND_REPORT_NUMBERS_INFO:
                return {
                    severity: 'info',
                    message: `${ExpectedExpenseCount} expenses and ${ExpectedReceiptCount} receipts will be added to the expense report.`,
                    hasTooltip: true,
                    tooltipMessage: TOOLTIP_MESSAGES.EXPENSE_AND_RECEIPTS
                };
            case ALERT_TYPE.DATE_RANGE_EXPENSE_AND_REPORT_NUMBERS_ERROR:
                return {
                    severity: 'error',
                    message: 'Your Wallet does not contain any receipts or expenses between the selected date range. Modify the date range or select a different option to continue.'
                };
            default:
                return null;
        }
    };
    const renderInfoAlertWithTooltip = (message, tooltipMessage) => (_jsx(Alert, { severity: "info", sx: INFO_ALERT_STYLES, children: _jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", children: [_jsx(Box, { children: $t(message) }), _jsx(Box, { children: _jsx(Tooltip, { title: $t(tooltipMessage), children: _jsx(Icon, { iconUrl: HelpIcon }) }) })] }) }));
    const renderSimpleAlert = (severity, message) => (_jsx(Alert, { severity: severity, children: $t(message) }));
    const renderAlert = (config) => {
        if (config.severity === 'info' && config.hasTooltip && config.tooltipMessage) {
            return renderInfoAlertWithTooltip(config.message, config.tooltipMessage);
        }
        return renderSimpleAlert(config.severity, config.message);
    };
    const alertConfig = getAlertConfig();
    if (!alertConfig) {
        return null;
    }
    return (_jsx(Box, { sx: { mt: '48px' }, "data-testid": "alert", children: renderAlert(alertConfig) }));
}
export default AlertMessage;
